export default __webpack_public_path__ + "static/media/logo-base.a02e3978.png";